<template>
  <div class=" page no-top-bar min-h-screen"  v-if="isLogin">
      <div class=" min-h-screen">
          <TopBarDetail
            :title="'แก้ไขข้อมูลส่วนตัว'"
            :isShowBack="true"
            :isShowFavorite="false"
            :isShowShare="false"
            @clickBack="clickBack()"
          >
          </TopBarDetail>
          <div class="px-4">
            <div class="bg-white rounded-lg shadow-md pt-7 px-4">
                <div class="flex flex-col justify-center items-center">
                    <div class="w-12 h-12">
                        <img class="w-full h-full" src="@/assets/icon/ic-user-blue.svg" alt="">
                    </div>
                    <div class="text-20 text-green-1 pt-5">
                        {{getLevelText()}}
                    </div>
                    <div class="pt-1 text-26 text-blue-1">
                        <span>{{userPoints}} &nbsp;</span>
                        <span>คะแนน</span>
                    </div>
                    <div class="divider bg-gray-2 w-full mt-4"></div>
                    <div class="pt-5">
                        <div class="flex flex-col justify-center items-center">
                                <FormUserInfo
                                    v-model:formValid="formValid"
                                    ref="FormUserInfo"
                                    :userInfo="formData"
                                    :formLbl="lbl.profile"
                                    :isShowError="isShowErrorFormUserInfo"
                                    :isSubmitted="isSubmittedFormUserInfo"
                                    :isDisable="true"
                                    :modalController="modalController"
                                >
                                </FormUserInfo>
                                <button
                                    @click="onSubmit()"
                                    class="w-full rounded-full text-white bg-green-1 text-center text-22 mb-4 py-2.5"
                                >
                                    บันทึก
                                </button>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </div>

      <ModalMaster :controller="modalController"></ModalMaster>
  </div>

</template>

<script>
// helper
import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import { UserLevel } from "@/core/UserLevel/UserLevelDetail.js";
// mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from "@/mixin/ModalMixin.js";
// component
import TopBarDetail from "@/components/Layout/TopBar/TopBarDetail.vue";
import FormUserInfo from "@/components/Form/FormUserInfo.vue";
// service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import BzbsAuth from '@/core/Account/service/BzbsAuth'

export default {
    name: "Edit Profile",
    mixins: [AuthPageMixin, LocaleMixin, ModalMixin],
    components: {
    TopBarDetail,
    FormUserInfo,
},
    data: function() {
        return {

            formData: null,
            isShowErrorFormUserInfo: false,
            isSubmittedFormUserInfo: false,

            formValid: false,

            userPoints: null,
        }
    },
    methods: {
        onAccountInit: function() {
            this.formData = {...this.profileCustom};

            let profile = this.profile;
            if (profile) {
                this.userPoints = profile.updated_points.points
            }

        },
        onSetupModalCompleted: function() {
            this.initialChangeMobileNumberModal();
        },
        clickBack: function() {
            this.$router.back();
        },
        onSubmit: async function () {
            this.userLevel = new UserLevel();
            let level = this.userLevel.getLevelVerifiedlaserno();
            if (!level) {
                this.modalController.confirmModal
                                    .clearModal()
                                    .setTag('verifiedlaserno')
                                    .setMsg(this.lbl.verify_laser_id.before_update_profile)
                                    .setBtnOk(this.lbl.verify_laser_id.confirm_btn)
                                    .show()
                this.modalController.confirmModal.onClickOk(() => {
                    let url = `${ConfigManager.getWebSofinUrl()}/editinfo?return_url=${this.$route.path.substring(1,this.$route.path.length)}`
                    window.location.replace(url);
                });
            } else {
                this.tracking.event('profile', 'click_save');
                this.isSubmittedFormUserInfo = true;
                if (this.$refs['FormUserInfo'].validate()) {
                    this.formUserInfo = this.$refs['FormUserInfo'].submit();
                    this.loadingModal.show();
                    BzbsProfile.updateProfileCustom(this.formUserInfo).subscribe({
                        next: (data) => {
                            console.log(data);
                            this.updateProfile();
                        },
                        error: (err) => {
                            this.errorApi(err);
                        }
                    });
                }
                if (!this.formValid) return;
            }

        },
        deviceResumeApi: function() {
            const token = Account.getToken();
            return new Promise((resolve) => {
                BzbsAuth.apiReLoginDevice(token, null).subscribe({
                    next: (data) => {
                        Account.setLogin(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        updateProfile: async function () {
            await this.deviceResumeApi();
            let isGetProfileCustom = await this.AccountStore.methods.getProfileCustom();
            if (isGetProfileCustom) {
                this.loadingModal.hide();
                this.modalController.alertModal.clearModal()
                                            .setMsg("บันทึกข้อมูลส่วนตัวสำเร็จ")
                                            .show();
                this.modalController.alertModal.onClickClose(()=> {
                    this.$router.back();
                });
            }
        },
        getLevelText: function () {
            let userLevel = Account.getUserLevel()
            if (this.isLogin) {
                if (userLevel == '1')
                    return "MEMBER";
                else if (userLevel == '2')
                    return "SILVER";
                else if (userLevel == '4')
                    return "ตรอ.คลับ";
                else
                    return "";
            } else {
                return "";
            }

        },
    }
}
</script>

<style lang="scss" scoped>
    .divider {
        height: 1px;
    }
</style>
